/**
 * PromptImprovementModal Component
 * Shows improved prompt with USE/Cancel options
 */

import React from 'react';
import ReactDOM from 'react-dom';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import './PromptImprovementModal.css';

interface PromptImprovementModalProps {
  isOpen: boolean;
  originalPrompt: string;
  improvedPrompt: string;
  isLoading: boolean;
  error?: string;
  onUse: () => void;
  onCancel: () => void;
}

export const PromptImprovementModal: React.FC<PromptImprovementModalProps> = ({
  isOpen,
  originalPrompt,
  improvedPrompt,
  isLoading,
  error,
  onUse,
  onCancel
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="prompt-improvement-overlay" onClick={onCancel}>
      <div 
        className="prompt-improvement-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="prompt-improvement-header">
          <AutoFixHighIcon className="magic-wand-icon" />
          <h3>Improved Prompt</h3>
          <button 
            className="close-button"
            onClick={onCancel}
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="prompt-improvement-content">
          {isLoading ? (
            <div className="loading-state">
              <div className="loading-spinner" />
              <p>Improving your prompt...</p>
            </div>
          ) : error ? (
            <div className="error-state">
              <p className="error-message">{error}</p>
            </div>
          ) : (
            <>
              <div className="prompt-section original">
                <label>Original:</label>
                <div className="prompt-text">{originalPrompt}</div>
              </div>
              
              <div className="prompt-section improved">
                <label>Improved:</label>
                <div className="prompt-text">{improvedPrompt}</div>
              </div>
            </>
          )}
        </div>

        <div className="prompt-improvement-actions">
          <button 
            className="cancel-button"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className="use-button"
            onClick={onUse}
            disabled={isLoading || !!error}
          >
            <CheckIcon fontSize="small" />
            Use Improved Prompt
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};

export default PromptImprovementModal;
